// src/notification/notificationService.js
import { messaging } from "./firebase";
import { getToken, onMessage } from "firebase/messaging";

// ✅ CALL THIS ONLY AFTER LOGIN
export async function initWebPush(parent_id = null, pediatrician_id = null) {
  const backendUrl = process.env.REACT_APP_NOTIFICATION_BACKEND_URL;
  console.log("🔔 Initializing Web Push...");
  if (!messaging) {
    console.error("❌ Browser does not support Firebase Messaging");
    return;
  }

  try {
    // ✅ Ask Notification Permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("❌ Notification permission denied");
      return;
    }

    // ✅ Register service worker
    const swReg = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );
    console.log("✅ Service Worker Registered:", swReg);

    // ✅ Get FCM Token
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: swReg,
    });

    if (!token) {
      console.warn("⚠ No FCM token received");
      return;
    }

    console.log("✅ FCM Token:", token);

    // ✅ Save token to backend
    await fetch(`${backendUrl}/api/save_web_token`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        parent_id,
        pediatrician_id,
        platform: "web",
        token,
      }),
    });

    // ✅ Listen to foreground notifications
    onMessage(messaging, (payload) => {
      console.log("📩 Foreground notification:", payload);
      const { title, body, icon } = payload.notification;

      new Notification(title, {
        body: body,
        icon: `${window.location.origin}/active.png`,
        data: payload.data,
      });
    });

    // ✅ Auto token refresh happens silently
    // ✅ Just re-fetch token every login/app start
    console.log("🔁 Token auto-refresh handled by browser");
  } catch (err) {
    console.error("🔥 Error in initWebPush:", err);
  }
}
